import styled from 'styled-components';

const CompanyName = styled.span`
  display: inline-block;
  margin-left: 8px;
  vertical-align: middle;
`;

export default CompanyName;
